















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import Button from 'frontend/components/Button.vue';

import { DcClassroom, DailyChallenge } from 'frontend/types/daily-challenges';
import { apiResolve } from 'frontend/router';
import { postData } from 'frontend/utils/ajax';

@Component({
  computed: {
    ...mapState('dailyChallenges', ['dc']),
  },
  components: {
    Button,
  },
})
export default class AddToClassrooms extends Vue {
  @Prop({ type: Array }) private classrooms!: DcClassroom[];
  private dc!: DailyChallenge;
  private showClassrooms = false;
  private classroomIds: number[] = [];
  private saveInProgress = false;
  private statusMessage = '';
  private isUpdateError = false;

  private get displayLabel(): string {
    return this.classrooms.length > 1 ? 'Add to Classrooms' : 'Add to Classroom';
  }

  private async save(): Promise<void> {
    if (!this.classroomIds.length) {
      return;
    }
    const apiParams = {
      name: 'api_dailyproblems_actions',
      params: {
        dcSlug: this.dc.slug,
      },
    };
    const apiUrl = apiResolve(apiParams).href;
    const data = {
      intent: 'add_dc_to_classroom',
      classroom_ids: this.classroomIds,
      dc_id: this.dc.id,
    };
    this.saveInProgress = true;
    try {
      const resp = await postData(apiUrl, data);
      if (resp.success) {
        this.$store.commit('dailyChallenges/setClassrooms', resp.classrooms);
        this.showStatus('Updated!');
      } else {
        this.showStatus('Something went wrong!', true);
      }
    } catch (err) {
      this.showStatus('Something went wrong!', true);
    }
    this.classroomIds = [];
    this.saveInProgress = false;
  }

  private showStatus(message: string, isError = false): void {
    this.statusMessage = message;
    this.isUpdateError = isError;
    setTimeout(() => {
      this.statusMessage = '';
      this.isUpdateError = false;
    }, 1500);
  }
}
